import { useAuth } from "components/auth";

function RequireAuth({ children }: { children: JSX.Element })  {

  let auth = useAuth();

  if (!auth.authService.isAuthenticated()) {
    auth.authService.authorise();
    return <></>;
   }

  if (auth.authService.isPending()) {
    return <></>;
  }

  return children;    
}

export default RequireAuth;